import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Cannabis Loudoun · Elevate Your Understanding</p>
        <h1>Welcome to Cannabis Loudoun.</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis policy and culture in our community. 
          Explore in-depth articles and resources to enhance your understanding of local cannabis laws and practices.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Read the Latest News
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and how they affect our community.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access a wealth of information about cannabis, including its benefits, risks, and responsible use.
          </p>
        </article>
        <article>
          <h2>Community Insights</h2>
          <p>
            Discover stories and perspectives from local advocates and experts in the cannabis space.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;